function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("pattern", {
  id: "pattern3129",
  patternTransform: "matrix(.26458334 0 0 .26458334 -76.445683 -5.7812651)",
  xlinkHref: "#pattern2874-7"
}), React.createElement("linearGradient", {
  id: "linearGradient5697",
  x1: -13.205618,
  x2: -13.205618,
  y1: 26.258963,
  y2: 47.30072,
  gradientTransform: "translate(13.877701,13.831199)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient4655"
}), React.createElement("clipPath", {
  id: "clipPath5738-4"
}, React.createElement("path", {
  d: "m0.45113544 39.688016c-0.24986192 0-0.4511331183 0.200755-0.4511331183 0.450619v20.944606c0 0.249864 0.2012711983 0.451135 0.4511331183 0.451135h3.47420686c0.2498645 0 0.4511357-0.201271 0.4511357-0.451135v-20.944606c0-0.249864-0.2012712-0.450619-0.4511357-0.450619z",
  color: "#000000"
})), React.createElement("filter", {
  id: "filter5465-7-2",
  x: -0.32505909,
  y: -0.025913246,
  width: 1.6501182,
  height: 1.0518265,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.07139097
})), React.createElement("linearGradient", {
  id: "linearGradient5475",
  x1: -13.205618,
  x2: -13.205618,
  y1: 26.258963,
  y2: 32.87096,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient4655"
}), React.createElement("clipPath", {
  id: "clipPath5401-9"
}, React.createElement("rect", {
  x: -13.8777,
  y: 25.856594,
  width: 4.3765388,
  height: 7.4167299,
  ry: 0.45101735,
  color: "#000000"
})), React.createElement("filter", {
  id: "filter5465",
  x: -0.32505909,
  y: -0.025913246,
  width: 1.6501182,
  height: 1.0518265,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.07139097
})), React.createElement("linearGradient", {
  id: "linearGradient5475-9",
  x1: -13.205618,
  x2: -13.205618,
  y1: 26.258963,
  y2: 39.268726,
  gradientTransform: "translate(13.877701,13.831199)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient4655"
}), React.createElement("clipPath", {
  id: "clipPath5589-3"
}, React.createElement("path", {
  d: "m0.45113526 39.688017c-0.2498636 0-0.45113526 0.200756-0.45113526 0.45062v12.912612c0 0.249864 0.20127166 0.451136 0.45113526 0.451136h3.47420684c0.2498635 0 0.4511352-0.201272 0.4511352-0.451136v-12.912612c0-0.249864-0.2012717-0.45062-0.4511352-0.45062z",
  color: "#000000"
})), React.createElement("filter", {
  id: "filter5465-7",
  x: -0.32505909,
  y: -0.025913246,
  width: 1.6501182,
  height: 1.0518265,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.07139097
})), React.createElement("clipPath", {
  id: "clipPath5589-7-8"
}, React.createElement("path", {
  d: "m0.45113526 39.688017c-0.2498636 0-0.45113526 0.200756-0.45113526 0.45062v12.912612c0 0.249864 0.20127166 0.451136 0.45113526 0.451136h3.47420684c0.2498635 0 0.4511352-0.201272 0.4511352-0.451136v-12.912612c0-0.249864-0.2012717-0.45062-0.4511352-0.45062z",
  color: "#000000"
})), React.createElement("filter", {
  id: "filter5465-7-8",
  x: -0.32505909,
  y: -0.025913246,
  width: 1.6501182,
  height: 1.0518265,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.07139097
})), React.createElement("clipPath", {
  id: "clipPath4960-5"
}, React.createElement("path", {
  d: "m56.734381 2.01367c-29.678552 0-53.5722709 23.893694-53.5722709 53.572268v610.443342c0 29.67855 23.8937189 53.57223 53.5722709 53.57223h246.531239c29.67859 0 53.57227-23.89368 53.57227-53.57223v-610.443342c0-29.678574-23.89368-53.572268-53.57227-53.572268zm-1.423823 3.9785157h249.378882c26.58218 0 47.98243 21.3983043 47.98243 47.9804723v614.236272c0 26.58217-21.40025 47.98246-47.98243 47.98246h-249.378882c-26.582175 0-47.9824257-21.40029-47.9824257-47.98246v-614.236272c0-26.582168 21.4002507-47.9804723 47.9824257-47.9804723z",
  color: "#000000",
  fill: "#ebebeb"
})), React.createElement("filter", {
  id: "filter4996",
  x: -0.0017457807,
  y: -0.00091419625,
  width: 1.0034916,
  height: 1.0018284,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.26620632
})), React.createElement("linearGradient", {
  id: "linearGradient5226",
  x1: 340.65216,
  x2: 349.57422,
  y1: 361.12305,
  y2: 361.12305,
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient5220"
}), React.createElement("linearGradient", {
  id: "linearGradient5220"
}, React.createElement("stop", {
  stopColor: "#404040",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#838383",
  offset: 0.59999961
}), React.createElement("stop", {
  stopColor: "#a7a7a7",
  offset: 1
})), React.createElement("linearGradient", {
  id: "linearGradient5226-6",
  x1: 340.65216,
  x2: 349.57422,
  y1: 361.12305,
  y2: 361.12305,
  gradientTransform: "matrix(-.26458334 0 0 .26458334 95.47647 7.5449331e-7)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient5220"
}), React.createElement("pattern", {
  id: "pattern2874-7",
  width: 1.171848,
  height: 1.1718804,
  patternTransform: "matrix(.26458334 0 0 .26458334 -76.445686 -5.7812643)",
  patternUnits: "userSpaceOnUse"
}, React.createElement("g", {
  transform: "matrix(3.7795274,0,0,3.7795274,288.92857,-26.720982)"
}, React.createElement("rect", {
  x: -76.445686,
  y: 7.0699267,
  width: 0.15502979,
  height: 0.15502979,
  fill: "#212121"
}), React.createElement("rect", {
  x: -76.290665,
  y: 7.224957,
  width: 0.15502979,
  height: 0.15502979,
  fill: "#212121"
}), React.createElement("rect", {
  x: -76.290665,
  y: 7.0699267,
  width: 0.15502979,
  height: 0.15502979,
  fill: "#060606"
}), React.createElement("rect", {
  x: -76.445686,
  y: 7.224957,
  width: 0.15502979,
  height: 0.15502979,
  fill: "#060606"
}))), React.createElement("filter", {
  id: "filter5343",
  x: -0.19227619,
  y: -0.082464501,
  width: 1.3845524,
  height: 1.164929,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.030983682
})), React.createElement("filter", {
  id: "filter5347",
  x: -0.10877967,
  y: -0.082313925,
  width: 1.2175593,
  height: 1.1646278,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.030983682
})), React.createElement("linearGradient", {
  id: "linearGradient5832",
  x1: 8.3152552,
  x2: 86.934753,
  y1: 8.4801025,
  y2: 8.4801025,
  gradientTransform: "translate(.06681739 -2.6058787)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient5830"
}), React.createElement("linearGradient", {
  id: "linearGradient5830"
}, React.createElement("stop", {
  stopColor: "#4f4f4f",
  stopOpacity: 0.13084112,
  offset: 0
}), React.createElement("stop", {
  stopColor: "#4f4f4f",
  offset: 0.07
}), React.createElement("stop", {
  stopColor: "#4f4f4f",
  stopOpacity: 0.95327103,
  offset: 0.93699998
}), React.createElement("stop", {
  stopColor: "#4f4f4f",
  stopOpacity: 0,
  offset: 1
})), React.createElement("linearGradient", {
  id: "linearGradient5832-3",
  x1: 8.3152552,
  x2: 86.934753,
  y1: 8.4801025,
  y2: 8.4801025,
  gradientTransform: "matrix(.99999998 0 0 -.99999998 .0668174 193.56681)",
  gradientUnits: "userSpaceOnUse",
  xlinkHref: "#linearGradient5830"
}), React.createElement("linearGradient", {
  id: "linearGradient2973",
  x1: -41.981419,
  x2: 137.23141,
  y1: 95.480484,
  y2: 95.480484,
  gradientTransform: "rotate(90,47.625001,95.48048)",
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#303030",
  offset: 0
}), React.createElement("stop", {
  stopColor: "#171717",
  offset: 1
})), React.createElement("mask", {
  id: "mask1062-8",
  maskUnits: "userSpaceOnUse"
}, React.createElement("path", {
  d: "m42.746746 7.2620904c-0.399166 0-0.72037 0.3212029-0.72037 0.7203695 0 0.3991665 0.321204 0.7203694 0.72037 0.7203694h9.921876c0.399166 0 0.72037-0.3212029 0.72037-0.7203694 0-0.3991666-0.321204-0.7203695-0.72037-0.7203695z",
  color: "#000000",
  fill: "none",
  stroke: "#fff",
  strokeLinecap: "round",
  strokeWidth: 0.05291667
})), React.createElement("filter", {
  id: "filter1214",
  x: -0.09973029,
  y: -2.5665836,
  width: 1.1994606,
  height: 6.1331673,
  colorInterpolationFilters: "sRGB"
}, React.createElement("feGaussianBlur", {
  stdDeviation: 0.49125426
})), React.createElement("linearGradient", {
  id: "linearGradient4655"
}, React.createElement("stop", {
  stopColor: "#5e6c62",
  stopOpacity: 0.27450982,
  offset: 0
}), React.createElement("stop", {
  stopColor: "#5e6c62",
  offset: 0.05
}), React.createElement("stop", {
  stopColor: "#5e6c62",
  offset: 0.94999999
}), React.createElement("stop", {
  stopColor: "#5e6c62",
  stopOpacity: 0.27450982,
  offset: 1
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "m94.798868 44.206385c0.249863 0 0.451135 0.200755 0.451135 0.45062v20.944605c0 0.249865-0.201272 0.451136-0.451135 0.451136h-3.474207c-0.249863 0-0.451135-0.201271-0.451135-0.451136v-20.944605c0-0.249865 0.201272-0.45062 0.451135-0.45062z",
  color: "#000000",
  fill: "#4e5c52"
}), React.createElement("path", {
  transform: "matrix(-1,0,0,1,95.250003,4.5183682)",
  d: "m0.547026 40.090161c-0.222752 0-0.402042 0.17929-0.402042 0.402042v20.237673c0 0.222752 0.17929 0.402042 0.402042 0.402042h0.125057v-21.041757z",
  clipPath: "url(#clipPath5738-4)",
  color: "#000000",
  fill: "url(#linearGradient5697)",
  filter: "url(#filter5465-7-2)"
}), React.createElement("rect", {
  x: -5.539465e-10,
  y: 25.856596,
  width: 4.3765388,
  height: 7.4167299,
  ry: 0.45101735,
  color: "#000000",
  fill: "#4e5c52"
}), React.createElement("path", {
  transform: "translate(13.877701)",
  d: "m-13.330675 26.258962c-0.222752 0-0.402042 0.17929-0.402042 0.402042v5.807914c0 0.222752 0.17929 0.402042 0.402042 0.402042h0.125057v-6.611998z",
  clipPath: "url(#clipPath5401-9)",
  color: "#000000",
  fill: "url(#linearGradient5475)",
  filter: "url(#filter5465)"
}), React.createElement("path", {
  d: "m0.45113526 39.688017c-0.2498636 0-0.45113526 0.200755-0.45113526 0.45062v12.912611c0 0.249865 0.20127166 0.451136 0.45113526 0.451136h3.47420674c0.2498635 0 0.4511353-0.201271 0.4511353-0.451136v-12.912611c0-0.249865-0.2012718-0.45062-0.4511353-0.45062z",
  color: "#000000",
  fill: "#4e5c52"
}), React.createElement("path", {
  d: "m0.547026 40.090161c-0.222752 0-0.402042 0.17929-0.402042 0.402042v12.205679c0 0.222752 0.17929 0.402042 0.402042 0.402042h0.125057v-13.009763z",
  clipPath: "url(#clipPath5589-3)",
  color: "#000000",
  fill: "url(#linearGradient5475-9)",
  filter: "url(#filter5465-7)"
}), React.createElement("path", {
  d: "m0.45113526 57.060536c-0.2498636 0-0.45113526 0.200755-0.45113526 0.45062v12.912611c0 0.249865 0.20127166 0.451136 0.45113526 0.451136h3.47420674c0.2498635 0 0.4511353-0.201271 0.4511353-0.451136v-12.912611c0-0.249865-0.2012718-0.45062-0.4511353-0.45062z",
  color: "#000000",
  fill: "#4e5c52"
}), React.createElement("path", {
  transform: "translate(0,17.372519)",
  d: "m0.547026 40.090161c-0.222752 0-0.402042 0.17929-0.402042 0.402042v12.205679c0 0.222752 0.17929 0.402042 0.402042 0.402042h0.125057v-13.009763z",
  clipPath: "url(#clipPath5589-7-8)",
  color: "#000000",
  fill: "url(#linearGradient5475-9)",
  filter: "url(#filter5465-7-8)"
}), React.createElement("path", {
  d: "m14.483352 0.19895344c-7.7365204 0-13.96452034 6.22800506-13.96452034 13.96452256v162.633474c0 7.73652 6.22799994 13.96504 13.96452034 13.96504h28.3006l0.57826-0.81958h2.052579 4.42041 2.052072l0.578778 0.81958h28.300591c7.73652 0 13.964529-6.22852 13.964529-13.96504v-162.633474c0-7.7365175-6.228009-13.96452256-13.964529-13.96452256z",
  color: "#000000",
  fill: "#3c4940"
})), React.createElement("rect", {
  x: 1.4644364,
  y: 1.0885143,
  width: 92.644859,
  height: 188.66818,
  ry: 13.323661,
  fillOpacity: 0.95794391
}), React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "m0.83665 171.20092h1.10225v-151.374739h-1.10225z",
  color: "#000000",
  fill: "#57645b"
}), React.createElement("path", {
  d: "m94.41336 172.5042h-1.10225v4.35943c0 7.0332-5.66215 12.69535-12.69535 12.69535h-65.98151c-7.0332 0-12.69535-5.66215-12.69535-12.69535v-4.35943h-1.10225v3.78272c0 7.85245 6.32187 14.17433 14.17432 14.17433h65.22807c7.85246 0 14.17432-6.32188 14.17432-14.17433z",
  color: "#000000",
  fill: "#57645b"
}), React.createElement("path", {
  transform: "scale(.26458334)",
  d: "m284.4707 2.265625v3.9785156h4.92383v-3.9785156zm-281.3085906 67.744141v4.923828h4.1660156v-4.923828zm349.5097706 0v4.923828h4.16601v-4.923828zm-349.5097706 577.048824v4.92579h4.1660156v-4.92579zm349.5097706 0v4.92579h4.16601v-4.92579zm-282.066411 69.38477v3.41016h4.923828v-3.41016z",
  color: "#000000",
  fill: "#424f46"
}), React.createElement("path", {
  d: "m94.41336 19.826181h-1.10225v151.374739h1.10225z",
  color: "#000000",
  fill: "#57645b"
}), React.createElement("path", {
  d: "m15.01097 0.59944663c-7.85245 0-14.17432 6.32187387-14.17432 14.17432937v3.749642h1.10225v-4.17649c0-7.0331973 5.66215-12.6948324 12.69535-12.6948324h65.98151c7.0332 0 12.69535 5.6616351 12.69535 12.6948324v4.17649h1.10225v-3.749642c0-7.8524555-6.32186-14.17432937-14.17432-14.17432937z",
  color: "#000000",
  fill: "#57645b"
})), React.createElement("path", {
  transform: "scale(.26458334)",
  d: "m37.923828 11.580078c-6.586783-0.167847-19.140624 1.825893-32.0312499 16.3125-18.7500001 21.071427-1.9648437 8.392578-1.9648437 8.392578s11.5184146-17.856306 27.5898436-20.177734c16.071431-2.321429 11.160156-3.929688 11.160156-3.929688s-1.759914-0.521362-4.753906-0.597656zm284.152342 0c-2.99399 0.0763-4.7539 0.597656-4.7539 0.597656s-4.91128 1.608257 11.16015 3.929688 27.58985 20.177734 27.58985 20.177734 16.78515 12.67885-1.96485-8.392578c-12.89062-14.48661-25.44446-16.480349-32.03125-16.3125zm-324.5156231 670.361332c-1.4382784-0.17232-0.4570319 2.28878 8.3320312 12.16601 18.7500009 21.07143 36.7851559 15.71485 36.7851559 15.71485s4.911277-1.60827-11.160156-3.92969c-16.071431-2.32146-27.5898436-20.17774-27.5898436-20.17774s-4.73713871-3.57814-6.3671875-3.77343zm364.8789031 0c-1.63004 0.19529-6.36718 3.77343-6.36718 3.77343s-11.51843 17.85628-27.58985 20.17774c-16.07146 2.32142-11.16015 3.92969-11.16015 3.92969s18.03514 5.35658 36.78515-15.71485c8.78907-9.87723 9.77031-12.33833 8.33203-12.16601z",
  clipPath: "url(#clipPath4960-5)",
  fill: "#3d4a41",
  fillRule: "evenodd",
  filter: "url(#filter4996)"
})), React.createElement("g", {
  transform: "translate(-.11323174)"
}, React.createElement("path", {
  transform: "scale(.26458334)",
  d: "m325.58008 15.363281c-1.17457-0.116312-0.62011 1.054663 2.01562 3.496094 8.69619 8.055118 14.09571 19.714101 14.09571 32.691406v309.572269 309.57226c0 12.97731-5.39952 24.63629-14.09571 32.69141-2.63573 2.44142-3.19019 3.6125-2.01562 3.49609 0.70474-0.0698 2.03219-0.60282 3.9043-1.60156 12.70949-6.7804 20.08984-21.40851 20.08984-36.94531v-307.21289-307.212894c0-15.536781-7.38036-30.164944-20.08984-36.945312-1.87211-0.998744-3.19956-1.531776-3.9043-1.601563z",
  color: "#000000",
  fill: "url(#linearGradient5226)"
}), React.createElement("path", {
  d: "m9.3334021 4.0648688c0.310772-0.03077 0.164071 0.279046-0.533299 0.925008-2.300868 2.13125-3.729491 5.2160232-3.729491 8.6496012v81.907666 81.907656c0 3.43358 1.428623 6.51836 3.729491 8.64961 0.69737 0.64596 0.844071 0.9558 0.533299 0.925-0.186462-0.0185-0.537684-0.15949-1.033013-0.42374-3.362719-1.79398-5.315437-5.66434-5.315437-9.77512v-81.283406-81.283414c0-4.110774 1.952721-7.9811422 5.315437-9.7751142 0.495329-0.264251 0.846551-0.405283 1.033013-0.423747z",
  color: "#000000",
  fill: "url(#linearGradient5226-6)"
})), React.createElement("g", null, React.createElement("rect", {
  x: 42.02623,
  y: 7.2618642,
  width: 11.36291,
  height: 1.4410343,
  ry: 0.72051716,
  color: "#000000",
  fill: "url(#pattern3129)"
}), React.createElement("circle", {
  cx: 57.914883,
  cy: 7.8897233,
  r: 1.3446997,
  color: "#000000",
  fill: "#161616"
}), React.createElement("circle", {
  cx: 57.914883,
  cy: 7.8897233,
  r: 1.0774301,
  color: "#000000",
  fill: "#0a0d13"
}), React.createElement("circle", {
  cx: 57.914883,
  cy: 7.8897233,
  r: 0.82091707,
  color: "#000000",
  fill: "#091427"
})), React.createElement("path", {
  d: "m57.349775 7.3405077c-0.09735 0.010246-0.235679 0.1588277-0.245928 0.4508659-0.01024 0.292038 0.117842 0.4508656 0.189571 0.4508656 0.07173 0 0.368889-0.4252483 0.05635-0.9017315z",
  fill: "#235a91",
  fillOpacity: 0.55607473,
  fillRule: "evenodd",
  filter: "url(#filter5343)"
}), React.createElement("path", {
  d: "m58.048878 7.2382402c-0.153553 0.0472469-0.183083 0.2952938-0.177178 0.4370348 0.0059 0.1417412 0.206706 0.5138116 0.448847 0.4311293 0.242142-0.0826823 0.283483-0.3897882 0.183084-0.5964939-0.100401-0.2067057-0.283483-0.3543525-0.454753-0.2716702z",
  fill: "#235a91",
  fillOpacity: 0.55607473,
  fillRule: "evenodd",
  filter: "url(#filter5347)"
}), React.createElement("g", null, React.createElement("path", {
  d: "m14.624068 2.5772674c-2.29857 0-4.436824 0.6574018-6.2419957 1.7921386v1.5048178c1.7203777-1.1284623 3.7800397-1.7854209 6.0001507-1.7854209h26.411827 13.795537 26.411825c2.220111 0 4.279774 0.6569586 6.000153 1.7854209v-1.5048178c-1.805173-1.1347368-3.943427-1.7921386-6.241998-1.7921386h-26.16998-13.795537z",
  color: "#000000",
  fill: "url(#linearGradient5832)"
}), React.createElement("path", {
  d: "m14.624068 188.38368c-2.29857 0-4.436824-0.65742-6.2419957-1.79215v-1.50481c1.7203777 1.12845 3.7800397 1.78541 6.0001507 1.78541h26.411827 13.795539 26.411823c2.220111 0 4.279774-0.65696 6.000153-1.78541v1.50481c-1.805173 1.13473-3.943427 1.79215-6.241998 1.79215h-26.169978-13.795539z",
  color: "#000000",
  fill: "url(#linearGradient5832-3)"
}), React.createElement("g", {
  id: "phone-content"
})), React.createElement("g", {
  fill: "#fff",
  fillOpacity: 0.06542059
}, React.createElement("circle", {
  cx: 29.091516,
  cy: 7.8897238,
  r: 0.89769351
}), React.createElement("circle", {
  cx: 65.011909,
  cy: 7.8897238,
  r: 1.6063988
}), React.createElement("circle", {
  cx: 36.640068,
  cy: 7.8897238,
  r: 1.3229167
})), React.createElement("path", {
  d: "m42.746746 7.2620885c-0.399166 0-0.72037 0.3212029-0.72037 0.7203695 0 0.3991665 0.321204 0.7203694 0.72037 0.7203694h9.921876c0.399166 0 0.72037-0.3212029 0.72037-0.7203694 0-0.3991666-0.321204-0.7203695-0.72037-0.7203695z",
  color: "#000000",
  fill: "none",
  stroke: "#292929",
  strokeLinecap: "round",
  strokeWidth: 0.05291667
}), React.createElement("g", {
  fill: "#fff",
  filter: "url(#filter1214)",
  mask: "url(#mask1062-8)"
}, React.createElement("path", {
  d: "m42.25606 7.9824588a0.22968481 0.22968481 0 0 1-0.229685 0.2296847 0.22968481 0.22968481 0 0 1-0.229685-0.2296847 0.22968481 0.22968481 0 0 1 0.229685-0.2296848 0.22968481 0.22968481 0 0 1 0.229685 0.2296848z"
}), React.createElement("path", {
  d: "m53.618677 7.9824588a0.22968481 0.22968481 0 0 1-0.229685 0.2296847 0.22968481 0.22968481 0 0 1-0.229685-0.2296847 0.22968481 0.22968481 0 0 1 0.229685-0.2296848 0.22968481 0.22968481 0 0 1 0.229685 0.2296848z"
})));

var SvgIphone = function SvgIphone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 360,
    height: 722,
    viewBox: "0 0 95.25 191.02918",
    className: "makeStyles-phone-978",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/iphone.cdcd25c8.svg";
export { ForwardRef as ReactComponent };